import React, { FC, useMemo } from 'react'

import styled from 'styled-components'

import { Txt, Tooltip } from 'src/components/atoms'

const CountTxt = styled(Txt)`
  font-size: var(--r3);
`

type Props = {
  title: string
  count?: number
  tooltipContent: React.ReactNode
  className?: string
}

export const ProjectInsightDetailItem: FC<Props> = ({
  title,
  count,
  tooltipContent,
  className,
}) => {
  const countText = useMemo(() => {
    if (!count) {
      return '-'
    }
    if (count.toString().length > 4) {
      return `${Math.round(count / 100) / 10}k`
    }
    return `${count.toLocaleString()}`
  }, [count])

  return (
    <div className={className}>
      <Tooltip content={tooltipContent} placement="top-start">
        <Txt sizeType="s" className="tw-text-standardText-secondary">
          {title}
        </Txt>
      </Tooltip>
      <CountTxt fontType="alphabet" className="tw-text-roovPrimary-default tw-font-bold tw-mt-s-3">
        {countText}
      </CountTxt>
    </div>
  )
}
